const reducer = (state = [], action) => {
  switch (action.type) {
    case "FETCH_TEST_TYPE":
      return action.payload;
    case "ADD_TEST_TYPE":
      return [...state, action.payload];
    case "UPDATE_TEST_TYPE":
      return state.map((item) =>
        item.id === action.payload.id ? action.payload : item
      );
    case "REMOVE_TEST_TYPE":
      return state.filter((s) => s.id !== action.payload);
    case "CLEAR_TEST_TYPE":
      return [];
    default:
      return state;
  }
};
export default reducer;
